import { render, staticRenderFns } from "./recommendedLine.vue?vue&type=template&id=4dafc15b"
import script from "./recommendedLine.vue?vue&type=script&lang=js"
export * from "./recommendedLine.vue?vue&type=script&lang=js"
import style0 from "./recommendedLine.vue?vue&type=style&index=0&id=4dafc15b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports